module.exports = __webpack_public_path__ + "img/logo.a4259df5.png";